/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CompanyAssessmentQuestionType {
	Text = 1,
	TextArea = 2,
	Number = 3,
	Decimal = 4,
	Select = 5,
	MultiSelect = 6,
	Date = 7,
}
